import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { callPost } from "utils/CommonApi";

import Constants from "common/Constants";
import PenderManager from "utils/PenderManager";

import CardAatb from "components/card/CardAatb";

import textbook_korean8 from "styles/common/img/myplan/textbook_korean8.png";

const AatbMainList = (props) => {
    const { getCourseAatb, getMmbrCourseAatb, setMmbrCourseAatb, courseAatbList, chk, setChk } = props;

    /* 세팅 정보 */
    const mode = useSelector((state) => state.settingReducer.mode);
    const dispatch = useDispatch();

    /* 사용자 정보 */
    const loginInfo = useSelector((state) => state.loginReducer);

    /* 탭 관련 상태값 */
    //const [chk, setChk] = useState(-1);

    useEffect(() => {
        let chkValue = -1;
        if (courseAatbList.length > 0) {
            let aatbInfo = getMmbrCourseAatb("COURSE_GRP_CD");
            chkValue = aatbInfo !== null && Boolean(aatbInfo.AATB_SEQ) ? aatbInfo.AATB_SEQ : -1;
        }

        setChk(chkValue);
    }, [courseAatbList]);

    useEffect(() => {
        if (Boolean(chk)) {
            let aatbInfo = getCourseAatb("AATB_SEQ", chk);

            // 회원 교과서 정보 변경
            if (aatbInfo !== null) {
                setMmbrCourseAatb(aatbInfo);
            } else {
                setMmbrCourseAatb();
            }
        } else {
            // 주석처리 -> chk 값이 없을 경우 처리 로직 삭제
            //setMmbrCourseAatb();
        }
    }, [chk]);

    return (
        <ul className="textbook">
            {courseAatbList?.map((aatb, index) => (
                <CardAatb key={index} chk={chk} setChk={setChk} aatb={aatb} />
            ))}
        </ul>
    );
};

export default AatbMainList;
